import { Component, OnInit } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { Router } from '@angular/router';

@Component({
  selector: 'app-idletimemodal',
  templateUrl: './idletimemodal.component.html',
  styleUrls: ['./idletimemodal.component.css']
})
export class IdletimemodalComponent implements OnInit {

  constructor(private userIdle: UserIdleService,
    private router:Router) { }

  ngOnInit(): void {
  }

  stop() {
    this.userIdle.stopTimer();
  }
 
  
  logout(){
    this.router.navigate(['/login']);
  }

}
